import React from 'react';
import {Helmet} from 'react-helmet';
import { Route,HashRouter } from 'react-router-dom';

// import components
import {
    Home,
    About,
    Skills,
    Projects,
    Contact,
    Loading,
    Navs,
    Email,
    Social,
    Footer
} from './components/Index';




function App() {

  return (
  
    <HashRouter>
    

    <div className="App">
      <Helmet>
        <style>{'body { background-color: #0A192F; }'}</style>

      </Helmet>
      <Navs />
    
        <Route exact path="/" component={Loading}/>
        <Route exact path="/home" component={Home}/>
        <Route exact path="/about" component={About} />
        <Route exact path="/skills" component={Skills} />
        <Route exact path="/projects" component={Projects} />
        <Route exact path="/contact" component={Contact}/>
      
        <Social />
        <Email />
        <Footer />
  
    </div>
    </HashRouter>
  );
}


export default App;
